import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-appl-pics',
  template: `
    <nz-divider></nz-divider>
    <iframe *ngIf="secureUrl" [src]="secureUrl" height="600px" width="100%"></iframe>
    <nz-divider></nz-divider>
    <p>
      <label [(ngModel)]="checked" nz-checkbox>
        I agree and understand the above terms and conditions
      </label>
    </p>
    <button nz-button (click)="agree()" [disabled]="!checked" nzType="primary">Agree and Continue</button>
  `,
  styles: []
})
export class ApplPicsComponent {
  @Input() iframeUrl = '';
  @Output() checkedChange = new EventEmitter<Boolean>();
  secureUrl?: SafeResourceUrl;

  checked = false;

  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }


  ngOnInit() {
    this.secureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
  }

  agree() {
    this.checkedChange.emit(this.checked);
  }


}
